// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"9":"Contact","70":"Room","162":"Restaurant","450":"About","570":"Site","756":"Events"}[chunkId] || chunkId) + "." + {"9":"2db59cee","70":"b0b39c36","162":"da5203eb","211":"557debff","450":"3c5676f6","493":"2d0ca704","570":"2908fbeb","756":"3c5676f6"}[chunkId] + ".css";
};